import { Box, Col, Link, Text } from '@opendoor/bricks-next';
import type { EntryComponent } from 'cms/entries/entries';
import type { ILpComponentFactBar, ILpElementFact } from 'declarations/contentful';

import Container from './shared/Container';

const FactItem = ({ fact, analyticsId }: { fact: ILpElementFact; analyticsId?: string }) => (
  <Col gap="$1" flex={1} minWidth="$35">
    <Text
      tag="p"
      typography="$labelXsmall"
      fontWeight="$medium"
      color="$contentTertiary"
      textTransform="uppercase"
    >
      {fact.fields.label}
    </Text>
    {fact.fields.valueLink ? (
      <Link
        href={fact.fields.valueLink}
        variant="primary"
        typography="$subheaderSmall"
        fontWeight="$medium"
        analyticsName={`cosmos-landing-page-v2-fact-bar-${analyticsId ?? ''}-${fact.sys?.id ?? ''}`}
      >
        {fact.fields.value}
      </Link>
    ) : (
      <Text tag="p" typography="$subheaderSmall" fontWeight="$medium" color="$contentPrimary">
        {fact.fields.value}
      </Text>
    )}
  </Col>
);

const renderFactBar = (entry: ILpComponentFactBar) => {
  const { items, eyebrow, analyticsId } = entry.fields;
  if (!items?.length) {
    return null;
  }

  return (
    <Container noSectionSpacing backgroundColor="$backgroundTertiary" className="py-8">
      <Col gap="$3">
        {eyebrow && (
          <Text tag="p" typography="$bodyMedium" fontWeight="$medium" color="$contentTertiary">
            {eyebrow}
          </Text>
        )}
        <Box
          flexDirection="column"
          gap="$6"
          $largerThanSM={{ flexDirection: 'row', flexWrap: 'wrap' }}
        >
          {items.map((fact, i) => (
            <FactItem key={fact.sys?.id ?? i} fact={fact} analyticsId={analyticsId} />
          ))}
        </Box>
      </Col>
    </Container>
  );
};

const FactBar: EntryComponent<ILpComponentFactBar> = {
  render: renderFactBar,
};

export default FactBar;
